import { Avatar, Button, Paper, Typography } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import Grid from "@mui/material/Grid2";
import { Stack } from "@mui/system";
import { formatDate, getTemplateType } from '../../../../../utils/ForcasterUtils';
import { useSelector } from 'react-redux';
import DataStatusAlert from '../../../Health/DataAccuracy/UI_HelpersOf_DataAccuracy/DataStatusAlert_Helpers';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CheckPermissions } from '../../../../../logic/Admin/Permissions/CheckPermission/CheckPermissions';
import { selectUserData, selectUserWebsitePermissions } from '../../../../../features/userSlice';

const ForeCasterInfoBase = ({ selectedForecaster }: any) => {
  const [searchParams] = useSearchParams();
  const websitePermissions = useSelector(selectUserWebsitePermissions) as any;
  const selectedSite = searchParams.get("selectedSite") as any;
  const navigate = useNavigate();

  const handleCreateNewVersion = () => {
    navigate(`/assets/overview/forecaster/Createnewforecast?${searchParams.toString()}`);
  };

  const response = useSelector(selectUserData);
  const hasCreateForcastersPermission = CheckPermissions(response?.data?.products?.assets, "overview", "create_forecasters");

  return (
    <>
      <Paper sx={{ padding: "8px 16px" }}>
        <Grid container spacing={3} alignItems="center" mb={2}>
          <Grid>
            <Stack flexDirection="row" alignItems="center" gap={2}>
              <Typography variant="h5" fontWeight={400}>
                Forecast Info
              </Typography>
              <DataStatusAlert status={selectedForecaster?.status ? selectedForecaster?.status : "N/A"} />
            </Stack>
          </Grid>
          <Grid size={7}>
            <Grid container spacing={2}>
              {/* Asset */}
              <Grid>
                <Stack flexDirection="row" gap={0.5}>
                  <Typography fontWeight={500}>Asset:</Typography>
                  <Typography fontWeight={400}>
                    {websitePermissions.find((site: any) => 
                      Object.keys(site)[0] === selectedSite
                    )?.[selectedSite]?.ui_site_name}
                  </Typography>
                </Stack>
              </Grid>
              {/* Created By */}
              <Grid>
                <Stack flexDirection="row" gap={0.5}>
                  <Typography fontWeight={500}>Created By:</Typography>
                  <Typography fontWeight={400}>
                    <Stack direction="row" gap={0.5} alignItems="center">
                      <Avatar sx={{ width: 24, height: 24 }} src="#" alt={selectedForecaster?.created_by} />
                      <Typography fontSize={14}>{selectedForecaster?.created_by}</Typography>
                    </Stack>
                  </Typography>
                </Stack>
              </Grid>
              {/* Created On */}
              <Grid>
                <Stack flexDirection="row" gap={0.5}>
                  <Typography fontWeight={500}>Created on:</Typography>
                  <Typography fontWeight={400}>{formatDate(selectedForecaster?.created)}</Typography>
                </Stack>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          container
          alignItems="center"
          spacing={2}
          sx={{ whiteSpace: "nowrap" }}
          mt={1}
          justifyContent="space-between"
        >
          <Grid size={6}>
            <Grid container spacing={2}>
              {/* Year */}
              <Grid size={2}>
                <Typography variant="body2" color="textSecondary">
                  Year
                </Typography>
                <Typography variant="body1">{selectedForecaster?.year}</Typography>
              </Grid>
              {/* Version */}
              <Grid size={2}>
                <Typography variant="body2" color="textSecondary">
                  Version
                </Typography>
                <Typography variant="body1">{selectedForecaster?.version}</Typography>
              </Grid>
              {/* Prediction Focus */}
              <Grid size={2}>
                <Typography variant="body2" color="textSecondary">
                  Prediction Focus
                </Typography>
                <Typography variant="body1">{getTemplateType(selectedForecaster?.template_type)}</Typography>
              </Grid>
              {/* Note */}
              <Grid size={6}>
                <Typography variant="body2" color="textSecondary">
                  Note
                </Typography>
                <Typography variant="body1" noWrap>
                  {selectedForecaster?.notes}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          {/* Button */}
          <Grid>
            {hasCreateForcastersPermission ? (
              <Button
                variant="contained"
                color="secondary"
                endIcon={<ContentCopyIcon />}
                data-tracker="133"
                onClick={handleCreateNewVersion}
              >
                CREATE NEW VERSION
              </Button>
            ) : (
              <Button
                disabled
                variant="contained"
                color="secondary"
                data-tracker="133"
                endIcon={<ContentCopyIcon />}
              >
                CREATE NEW VERSION
              </Button>
            )}
          </Grid>
        </Grid>
      </Paper>
    </>
  );
};

export default ForeCasterInfoBase;
